import { useState } from "react";
import { FaArrowRight, FaExpand } from "react-icons/fa";
import ProcessmodellModal from "./ProcessmodellModal";

export default function ArbetssattModal({ onClose }) {
  const [showProcess, setShowProcess] = useState(false);

  return (
    <>
      <div
        className="
          fixed inset-0 z-[100]
          flex items-center justify-center
          bg-neutral-950/50
          p-4
          backdrop-blur-sm
        "
        onClick={onClose}
      >
        <div
          className="
            relative
            max-h-[90vh]
            w-full
            max-w-5xl
            overflow-hidden
            rounded-[30px]
            border
            border-neutral-200
            bg-white
            shadow-[0_30px_100px_rgba(0,0,0,0.25)]
          "
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-start justify-between border-b border-neutral-100 px-8 py-8">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#3BAFA3]">
                02 · Metodbeskrivningen
              </p>

              <h2 className="mt-3 text-4xl font-semibold tracking-[-0.05em] text-neutral-900">
                Från möte till nästa steg
              </h2>
            </div>

            <button
              onClick={onClose}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-100 text-xl"
            >
              ×
            </button>
          </div>

          {/* Content */}
          <div className="max-h-[calc(90vh-120px)] overflow-y-auto px-8 py-10">

            <div className="max-w-3xl">
              <p className="text-lg leading-8 text-neutral-600">
                Räkna med mig bygger på samverkan mellan flera olika
                verksamheter. Processmodellen visar hur arbetet kan gå till –
                från att ett behov uppmärksammas till planering, stöd,
                uppföljning och nästa steg mot arbete, studier eller annan
                meningsfull sysselsättning.
              </p>

              <p className="mt-6 text-lg leading-8 text-neutral-600">
                Modellen hjälper oss att skapa en gemensam förståelse för hur
                olika aktörer kan bidra och hur stödet kan bli mer
                sammanhållet för den unga.
              </p>
            </div>

            {/* Bild */}
            <div className="mt-12">
              <button
                onClick={() => setShowProcess(true)}
                className="
                  group
                  block
                  w-full
                  overflow-hidden
                  rounded-[28px]
                  border
                  border-neutral-200
                  bg-[#F8FAFA]
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:shadow-[0_20px_60px_rgba(0,0,0,0.08)]
                "
              >
                <img
                  src="/Processmodellen.jpg"
                  alt="Processmodell"
                  className="w-full"
                />

                <div className="flex items-center justify-between px-8 py-6">
                  <div>
                    <h3 className="text-xl font-semibold text-neutral-900">
                      Visa processmodellen i större format
                    </h3>

                    <p className="mt-2 text-sm text-neutral-500">
                      Klicka för att öppna modellen i helskärm.
                    </p>
                  </div>

                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#3BAFA3] text-white">
                    <FaExpand size={16} />
                  </div>
                </div>
              </button>
            </div>

            {/* Steg */}
            <div className="mt-16 grid gap-5 md:grid-cols-4">

              {[
                [
                  "01",
                  "Identifiera behov",
                  "Olika aktörer uppmärksammar att en ung person kan behöva stöd."
                ],
                [
                  "02",
                  "Skapa kontakt",
                  "Gemensamma möten och planering tillsammans med individen."
                ],
                [
                  "03",
                  "Följa upp",
                  "Stöd och planering utvecklas utifrån individens behov."
                ],
                [
                  "04",
                  "Nästa steg",
                  "Studier, arbete eller annan meningsfull sysselsättning."
                ]
              ].map(([nr, title, text]) => (
                <div
                  key={nr}
                  className="rounded-[24px] bg-[#F8FAFA] p-6"
                >
                  <div className="text-sm font-semibold text-[#3BAFA3]">
                    {nr}
                  </div>

                  <h3 className="mt-5 text-lg font-semibold text-neutral-900">
                    {title}
                  </h3>

                  <p className="mt-3 text-sm leading-7 text-neutral-600">
                    {text}
                  </p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {showProcess && (
        <ProcessmodellModal
          onClose={() => setShowProcess(false)}
        />
      )}
    </>
  );
}